module.exports = __webpack_public_path__ + "img/order2erp.361bcbea.png";